export { signatureJSONToSVG } from './svg';
export { aesEncrypt, aesDecrypt } from './aes';

export const getPropsFromObject = (...propKeys) => object => propKeys.reduce((resultObject, key) => ({
  ...resultObject,
  [key]: object[key] ?? null
}), {});

const regionCodes = {
  北京: 'BJ',
  上海: 'SH',
  廣州: 'GZ',
  广州: 'GZ',
  深圳: 'SZ'
};
export const getRegionCode = address => Object.entries(regionCodes).reduce((result, [region, code]) => address.includes(region) ? code : result, false);

export const formatLessonItems = (Items) =>
  Items.reduce(
    (
      formattedLesson,
      { Qty, Code, Gross, Amount, Description, Discount = 0 }
    ) => {
      if (Code !== "") {
        formattedLesson.push({
          code: Code,
          name: Description,
          items: [],
        });
      } else if (formattedLesson.length > 0) {
        formattedLesson[formattedLesson.length - 1].items?.push({
          name: Description,
          qty: Qty,
          price: Amount / Qty,
          totalPrice: Amount,
          discount: 0,
          gross: Gross,
        });
      }
      return formattedLesson;
    },
    []
  );

export const copyToClipboard = string => {
  const textArea = document.createElement('textarea');
  textArea.value = string;
  textArea.setAttribute('readonly', true);
  textArea.style.width = 1;
  textArea.style.height = 1;
  textArea.style.padding = 0;
  textArea.style.border = 0;
  textArea.style.position = 'absolute';
  textArea.style.left = '-9999px';

  document.body.appendChild(textArea);
  const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
  textArea.focus();
  textArea.select();
  try {
    const successful = document.execCommand('copy');
    console.log(`Copying text command was ${successful ? 'successful' : 'unsuccessful'}.`);
  } catch (err) {
    console.log('Oops, unable to copy.');
  }
  document.body.removeChild(textArea);
  if (selected) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }
};